import "../../assets/index12.css";
import { jsxs as cn, jsx as We } from "react/jsx-runtime";
import Re, { forwardRef as vr, useState as fn } from "react";
import { ButtonIcon as ln } from "../../react/ButtonIcon.js";
import { m as dr } from "../../chunks/make-refs.cb0b9b76.js";
import { c as Ne } from "../../chunks/index.bddf5ebb.js";
function vn(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function gr(e, n, t) {
  return n && vn(e.prototype, n), t && vn(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var dn = "(prefers-reduced-motion: reduce)", De = 1, hr = 2, xe = 3, Ue = 4, je = 5, ut = 6, vt = 7, Er = {
  CREATED: De,
  MOUNTED: hr,
  IDLE: xe,
  MOVING: Ue,
  SCROLLING: je,
  DRAGGING: ut,
  DESTROYED: vt
};
function ge(e) {
  e.length = 0;
}
function ye(e, n, t) {
  return Array.prototype.slice.call(e, n, t);
}
function B(e) {
  return e.bind.apply(e, [null].concat(ye(arguments, 1)));
}
var In = setTimeout, Ct = function() {
};
function gn(e) {
  return requestAnimationFrame(e);
}
function mt(e, n) {
  return typeof n === e;
}
function Ye(e) {
  return !Gt(e) && mt("object", e);
}
var Bt = Array.isArray, On = B(mt, "function"), _e = B(mt, "string"), et = B(mt, "undefined");
function Gt(e) {
  return e === null;
}
function Pn(e) {
  try {
    return e instanceof (e.ownerDocument.defaultView || window).HTMLElement;
  } catch {
    return !1;
  }
}
function tt(e) {
  return Bt(e) ? e : [e];
}
function re(e, n) {
  tt(e).forEach(n);
}
function Wt(e, n) {
  return e.indexOf(n) > -1;
}
function ct(e, n) {
  return e.push.apply(e, tt(n)), e;
}
function le(e, n, t) {
  e && re(n, function(r) {
    r && e.classList[t ? "add" : "remove"](r);
  });
}
function se(e, n) {
  le(e, _e(n) ? n.split(" ") : n, !0);
}
function nt(e, n) {
  re(n, e.appendChild.bind(e));
}
function Ht(e, n) {
  re(e, function(t) {
    var r = (n || t).parentNode;
    r && r.insertBefore(t, n);
  });
}
function $e(e, n) {
  return Pn(e) && (e.msMatchesSelector || e.matches).call(e, n);
}
function wn(e, n) {
  var t = e ? ye(e.children) : [];
  return n ? t.filter(function(r) {
    return $e(r, n);
  }) : t;
}
function rt(e, n) {
  return n ? wn(e, n)[0] : e.firstElementChild;
}
var qe = Object.keys;
function Ie(e, n, t) {
  return e && (t ? qe(e).reverse() : qe(e)).forEach(function(r) {
    r !== "__proto__" && n(e[r], r);
  }), e;
}
function Ke(e) {
  return ye(arguments, 1).forEach(function(n) {
    Ie(n, function(t, r) {
      e[r] = n[r];
    });
  }), e;
}
function me(e) {
  return ye(arguments, 1).forEach(function(n) {
    Ie(n, function(t, r) {
      Bt(t) ? e[r] = t.slice() : Ye(t) ? e[r] = me({}, Ye(e[r]) ? e[r] : {}, t) : e[r] = t;
    });
  }), e;
}
function hn(e, n) {
  re(n || qe(e), function(t) {
    delete e[t];
  });
}
function ue(e, n) {
  re(e, function(t) {
    re(n, function(r) {
      t && t.removeAttribute(r);
    });
  });
}
function x(e, n, t) {
  Ye(n) ? Ie(n, function(r, i) {
    x(e, i, r);
  }) : re(e, function(r) {
    Gt(t) || t === "" ? ue(r, n) : r.setAttribute(n, String(t));
  });
}
function Me(e, n, t) {
  var r = document.createElement(e);
  return n && (_e(n) ? se(r, n) : x(r, n)), t && nt(t, r), r;
}
function ie(e, n, t) {
  if (et(t))
    return getComputedStyle(e)[n];
  Gt(t) || (e.style[n] = "" + t);
}
function Ze(e, n) {
  ie(e, "display", n);
}
function bn(e) {
  e.setActive && e.setActive() || e.focus({
    preventScroll: !0
  });
}
function ae(e, n) {
  return e.getAttribute(n);
}
function En(e, n) {
  return e && e.classList.contains(n);
}
function te(e) {
  return e.getBoundingClientRect();
}
function Oe(e) {
  re(e, function(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
  });
}
function Cn(e) {
  return rt(new DOMParser().parseFromString(e, "text/html").body);
}
function fe(e, n) {
  e.preventDefault(), n && (e.stopPropagation(), e.stopImmediatePropagation());
}
function Dn(e, n) {
  return e && e.querySelector(n);
}
function Xt(e, n) {
  return n ? ye(e.querySelectorAll(n)) : [];
}
function ve(e, n) {
  le(e, n, !1);
}
function Dt(e) {
  return e.timeStamp;
}
function Le(e) {
  return _e(e) ? e : e ? e + "px" : "";
}
var it = "splide", Yt = "data-" + it;
function He(e, n) {
  if (!e)
    throw new Error("[" + it + "] " + (n || ""));
}
var Ae = Math.min, dt = Math.max, gt = Math.floor, Je = Math.ceil, j = Math.abs;
function Mn(e, n, t) {
  return j(e - n) < t;
}
function ft(e, n, t, r) {
  var i = Ae(n, t), v = dt(n, t);
  return r ? i < e && e < v : i <= e && e <= v;
}
function be(e, n, t) {
  var r = Ae(n, t), i = dt(n, t);
  return Ae(dt(r, e), i);
}
function Mt(e) {
  return +(e > 0) - +(e < 0);
}
function Vt(e, n) {
  return re(n, function(t) {
    e = e.replace("%s", "" + t);
  }), e;
}
function $t(e) {
  return e < 10 ? "0" + e : "" + e;
}
var mn = {};
function mr(e) {
  return "" + e + $t(mn[e] = (mn[e] || 0) + 1);
}
function Vn() {
  var e = [];
  function n(a, u, c, l) {
    i(a, u, function(o, A, d) {
      var g = "addEventListener" in o, s = g ? o.removeEventListener.bind(o, A, c, l) : o.removeListener.bind(o, c);
      g ? o.addEventListener(A, c, l) : o.addListener(c), e.push([o, A, d, c, s]);
    });
  }
  function t(a, u, c) {
    i(a, u, function(l, o, A) {
      e = e.filter(function(d) {
        return d[0] === l && d[1] === o && d[2] === A && (!c || d[3] === c) ? (d[4](), !1) : !0;
      });
    });
  }
  function r(a, u, c) {
    var l, o = !0;
    return typeof CustomEvent == "function" ? l = new CustomEvent(u, {
      bubbles: o,
      detail: c
    }) : (l = document.createEvent("CustomEvent"), l.initCustomEvent(u, o, !1, c)), a.dispatchEvent(l), l;
  }
  function i(a, u, c) {
    re(a, function(l) {
      l && re(u, function(o) {
        o.split(" ").forEach(function(A) {
          var d = A.split(".");
          c(l, d[0], d[1]);
        });
      });
    });
  }
  function v() {
    e.forEach(function(a) {
      a[4]();
    }), ge(e);
  }
  return {
    bind: n,
    unbind: t,
    dispatch: r,
    destroy: v
  };
}
var pe = "mounted", xt = "ready", he = "move", ze = "moved", qt = "click", xn = "active", kn = "inactive", Fn = "visible", Un = "hidden", $ = "refresh", J = "updated", ke = "resize", _t = "resized", zn = "drag", Bn = "dragging", Gn = "dragged", At = "scroll", we = "scrolled", _r = "overflow", Kt = "destroy", Wn = "arrows:mounted", Hn = "arrows:updated", Xn = "pagination:mounted", Yn = "pagination:updated", Zt = "navigation:mounted", Jt = "autoplay:play", $n = "autoplay:playing", Qt = "autoplay:pause", jt = "lazyload:loaded", qn = "sk", Kn = "sh", ht = "ei";
function H(e) {
  var n = e ? e.event.bus : document.createDocumentFragment(), t = Vn();
  function r(v, a) {
    t.bind(n, tt(v).join(" "), function(u) {
      a.apply(a, Bt(u.detail) ? u.detail : []);
    });
  }
  function i(v) {
    t.dispatch(n, v, ye(arguments, 1));
  }
  return e && e.event.on(Kt, t.destroy), Ke(t, {
    bus: n,
    on: r,
    off: B(t.unbind, n),
    emit: i
  });
}
function yt(e, n, t, r) {
  var i = Date.now, v, a = 0, u, c = !0, l = 0;
  function o() {
    if (!c) {
      if (a = e ? Ae((i() - v) / e, 1) : 1, t && t(a), a >= 1 && (n(), v = i(), r && ++l >= r))
        return d();
      u = gn(o);
    }
  }
  function A(h) {
    h || s(), v = i() - (h ? a * e : 0), c = !1, u = gn(o);
  }
  function d() {
    c = !0;
  }
  function g() {
    v = i(), a = 0, t && t(a);
  }
  function s() {
    u && cancelAnimationFrame(u), a = 0, u = 0, c = !0;
  }
  function f(h) {
    e = h;
  }
  function _() {
    return c;
  }
  return {
    start: A,
    rewind: g,
    pause: d,
    cancel: s,
    set: f,
    isPaused: _
  };
}
function Ar(e) {
  var n = e;
  function t(i) {
    n = i;
  }
  function r(i) {
    return Wt(tt(i), n);
  }
  return {
    set: t,
    is: r
  };
}
function yr(e, n) {
  var t = yt(n || 0, e, null, 1);
  return function() {
    t.isPaused() && t.start();
  };
}
function pr(e, n, t) {
  var r = e.state, i = t.breakpoints || {}, v = t.reducedMotion || {}, a = Vn(), u = [];
  function c() {
    var s = t.mediaQuery === "min";
    qe(i).sort(function(f, _) {
      return s ? +f - +_ : +_ - +f;
    }).forEach(function(f) {
      o(i[f], "(" + (s ? "min" : "max") + "-width:" + f + "px)");
    }), o(v, dn), A();
  }
  function l(s) {
    s && a.destroy();
  }
  function o(s, f) {
    var _ = matchMedia(f);
    a.bind(_, "change", A), u.push([s, _]);
  }
  function A() {
    var s = r.is(vt), f = t.direction, _ = u.reduce(function(h, m) {
      return me(h, m[1].matches ? m[0] : {});
    }, {});
    hn(t), g(_), t.destroy ? e.destroy(t.destroy === "completely") : s ? (l(!0), e.mount()) : f !== t.direction && e.refresh();
  }
  function d(s) {
    matchMedia(dn).matches && (s ? me(t, v) : hn(t, qe(v)));
  }
  function g(s, f, _) {
    me(t, s), f && me(Object.getPrototypeOf(t), s), (_ || !r.is(De)) && e.emit(J, t);
  }
  return {
    setup: c,
    destroy: l,
    reduce: d,
    set: g
  };
}
var pt = "Arrow", St = pt + "Left", Tt = pt + "Right", Zn = pt + "Up", Jn = pt + "Down", _n = "rtl", Nt = "ttb", Ot = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [Zn, Tt],
  ArrowRight: [Jn, St]
};
function Sr(e, n, t) {
  function r(v, a, u) {
    u = u || t.direction;
    var c = u === _n && !a ? 1 : u === Nt ? 0 : -1;
    return Ot[v] && Ot[v][c] || v.replace(/width|left|right/i, function(l, o) {
      var A = Ot[l.toLowerCase()][c] || l;
      return o > 0 ? A.charAt(0).toUpperCase() + A.slice(1) : A;
    });
  }
  function i(v) {
    return v * (t.direction === _n ? 1 : -1);
  }
  return {
    resolve: r,
    orient: i
  };
}
var de = "role", Ve = "tabindex", Tr = "disabled", oe = "aria-", at = oe + "controls", Qn = oe + "current", An = oe + "selected", ne = oe + "label", en = oe + "labelledby", jn = oe + "hidden", tn = oe + "orientation", Qe = oe + "roledescription", yn = oe + "live", pn = oe + "busy", Sn = oe + "atomic", nn = [de, Ve, Tr, at, Qn, ne, en, jn, tn, Qe], ce = it + "__", Se = "is-", Pt = it, Tn = ce + "track", Nr = ce + "list", Lt = ce + "slide", er = Lt + "--clone", Lr = Lt + "__container", rn = ce + "arrows", Rt = ce + "arrow", tr = Rt + "--prev", nr = Rt + "--next", It = ce + "pagination", rr = It + "__page", Rr = ce + "progress", Ir = Rr + "__bar", Or = ce + "toggle", Pr = ce + "spinner", wr = ce + "sr", br = Se + "initialized", Pe = Se + "active", ir = Se + "prev", ar = Se + "next", kt = Se + "visible", Ft = Se + "loading", or = Se + "focus-in", sr = Se + "overflow", Cr = [Pe, kt, ir, ar, Ft, or, sr], Dr = {
  slide: Lt,
  clone: er,
  arrows: rn,
  arrow: Rt,
  prev: tr,
  next: nr,
  pagination: It,
  page: rr,
  spinner: Pr
};
function Mr(e, n) {
  if (On(e.closest))
    return e.closest(n);
  for (var t = e; t && t.nodeType === 1 && !$e(t, n); )
    t = t.parentElement;
  return t;
}
var Vr = 5, Nn = 200, ur = "touchstart mousedown", wt = "touchmove mousemove", bt = "touchend touchcancel mouseup click";
function xr(e, n, t) {
  var r = H(e), i = r.on, v = r.bind, a = e.root, u = t.i18n, c = {}, l = [], o = [], A = [], d, g, s;
  function f() {
    E(), D(), m();
  }
  function _() {
    i($, h), i($, f), i(J, m), v(document, ur + " keydown", function(y) {
      s = y.type === "keydown";
    }, {
      capture: !0
    }), v(a, "focusin", function() {
      le(a, or, !!s);
    });
  }
  function h(y) {
    var O = nn.concat("style");
    ge(l), ve(a, o), ve(d, A), ue([d, g], O), ue(a, y ? O : ["style", Qe]);
  }
  function m() {
    ve(a, o), ve(d, A), o = b(Pt), A = b(Tn), se(a, o), se(d, A), x(a, ne, t.label), x(a, en, t.labelledby);
  }
  function E() {
    d = L("." + Tn), g = rt(d, "." + Nr), He(d && g, "A track/list element is missing."), ct(l, wn(g, "." + Lt + ":not(." + er + ")")), Ie({
      arrows: rn,
      pagination: It,
      prev: tr,
      next: nr,
      bar: Ir,
      toggle: Or
    }, function(y, O) {
      c[O] = L("." + y);
    }), Ke(c, {
      root: a,
      track: d,
      list: g,
      slides: l
    });
  }
  function D() {
    var y = a.id || mr(it), O = t.role;
    a.id = y, d.id = d.id || y + "-track", g.id = g.id || y + "-list", !ae(a, de) && a.tagName !== "SECTION" && O && x(a, de, O), x(a, Qe, u.carousel), x(g, de, "presentation");
  }
  function L(y) {
    var O = Dn(a, y);
    return O && Mr(O, "." + Pt) === a ? O : void 0;
  }
  function b(y) {
    return [y + "--" + t.type, y + "--" + t.direction, t.drag && y + "--draggable", t.isNavigation && y + "--nav", y === Pt && Pe];
  }
  return Ke(c, {
    setup: f,
    mount: _,
    destroy: h
  });
}
var Fe = "slide", Be = "loop", ot = "fade";
function kr(e, n, t, r) {
  var i = H(e), v = i.on, a = i.emit, u = i.bind, c = e.Components, l = e.root, o = e.options, A = o.isNavigation, d = o.updateOnMove, g = o.i18n, s = o.pagination, f = o.slideFocus, _ = c.Direction.resolve, h = ae(r, "style"), m = ae(r, ne), E = t > -1, D = rt(r, "." + Lr), L;
  function b() {
    E || (r.id = l.id + "-slide" + $t(n + 1), x(r, de, s ? "tabpanel" : "group"), x(r, Qe, g.slide), x(r, ne, m || Vt(g.slideLabel, [n + 1, e.length]))), y();
  }
  function y() {
    u(r, "click", B(a, qt, M)), u(r, "keydown", B(a, qn, M)), v([ze, Kn, we], T), v(Zt, F), d && v(he, C);
  }
  function O() {
    L = !0, i.destroy(), ve(r, Cr), ue(r, nn), x(r, "style", h), x(r, ne, m || "");
  }
  function F() {
    var w = e.splides.map(function(S) {
      var P = S.splide.Components.Slides.getAt(n);
      return P ? P.slide.id : "";
    }).join(" ");
    x(r, ne, Vt(g.slideX, (E ? t : n) + 1)), x(r, at, w), x(r, de, f ? "button" : ""), f && ue(r, Qe);
  }
  function C() {
    L || T();
  }
  function T() {
    if (!L) {
      var w = e.index;
      N(), R(), le(r, ir, n === w - 1), le(r, ar, n === w + 1);
    }
  }
  function N() {
    var w = k();
    w !== En(r, Pe) && (le(r, Pe, w), x(r, Qn, A && w || ""), a(w ? xn : kn, M));
  }
  function R() {
    var w = X(), S = !w && (!k() || E);
    if (e.state.is([Ue, je]) || x(r, jn, S || ""), x(Xt(r, o.focusableNodes || ""), Ve, S ? -1 : ""), f && x(r, Ve, S ? -1 : 0), w !== En(r, kt) && (le(r, kt, w), a(w ? Fn : Un, M)), !w && document.activeElement === r) {
      var P = c.Slides.getAt(e.index);
      P && bn(P.slide);
    }
  }
  function V(w, S, P) {
    ie(P && D || r, w, S);
  }
  function k() {
    var w = e.index;
    return w === n || o.cloneStatus && w === t;
  }
  function X() {
    if (e.is(ot))
      return k();
    var w = te(c.Elements.track), S = te(r), P = _("left", !0), U = _("right", !0);
    return gt(w[P]) <= Je(S[P]) && gt(S[U]) <= Je(w[U]);
  }
  function W(w, S) {
    var P = j(w - n);
    return !E && (o.rewind || e.is(Be)) && (P = Ae(P, e.length - P)), P <= S;
  }
  var M = {
    index: n,
    slideIndex: t,
    slide: r,
    container: D,
    isClone: E,
    mount: b,
    destroy: O,
    update: T,
    style: V,
    isWithin: W
  };
  return M;
}
function Fr(e, n, t) {
  var r = H(e), i = r.on, v = r.emit, a = r.bind, u = n.Elements, c = u.slides, l = u.list, o = [];
  function A() {
    d(), i($, g), i($, d);
  }
  function d() {
    c.forEach(function(T, N) {
      f(T, N, -1);
    });
  }
  function g() {
    L(function(T) {
      T.destroy();
    }), ge(o);
  }
  function s() {
    L(function(T) {
      T.update();
    });
  }
  function f(T, N, R) {
    var V = kr(e, N, R, T);
    V.mount(), o.push(V), o.sort(function(k, X) {
      return k.index - X.index;
    });
  }
  function _(T) {
    return T ? b(function(N) {
      return !N.isClone;
    }) : o;
  }
  function h(T) {
    var N = n.Controller, R = N.toIndex(T), V = N.hasFocus() ? 1 : t.perPage;
    return b(function(k) {
      return ft(k.index, R, R + V - 1);
    });
  }
  function m(T) {
    return b(T)[0];
  }
  function E(T, N) {
    re(T, function(R) {
      if (_e(R) && (R = Cn(R)), Pn(R)) {
        var V = c[N];
        V ? Ht(R, V) : nt(l, R), se(R, t.classes.slide), O(R, B(v, ke));
      }
    }), v($);
  }
  function D(T) {
    Oe(b(T).map(function(N) {
      return N.slide;
    })), v($);
  }
  function L(T, N) {
    _(N).forEach(T);
  }
  function b(T) {
    return o.filter(On(T) ? T : function(N) {
      return _e(T) ? $e(N.slide, T) : Wt(tt(T), N.index);
    });
  }
  function y(T, N, R) {
    L(function(V) {
      V.style(T, N, R);
    });
  }
  function O(T, N) {
    var R = Xt(T, "img"), V = R.length;
    V ? R.forEach(function(k) {
      a(k, "load error", function() {
        --V || N();
      });
    }) : N();
  }
  function F(T) {
    return T ? c.length : o.length;
  }
  function C() {
    return o.length > t.perPage;
  }
  return {
    mount: A,
    destroy: g,
    update: s,
    register: f,
    get: _,
    getIn: h,
    getAt: m,
    add: E,
    remove: D,
    forEach: L,
    filter: b,
    style: y,
    getLength: F,
    isEnough: C
  };
}
function Ur(e, n, t) {
  var r = H(e), i = r.on, v = r.bind, a = r.emit, u = n.Slides, c = n.Direction.resolve, l = n.Elements, o = l.root, A = l.track, d = l.list, g = u.getAt, s = u.style, f, _, h;
  function m() {
    E(), v(window, "resize load", yr(B(a, ke))), i([J, $], E), i(ke, D);
  }
  function E() {
    f = t.direction === Nt, ie(o, "maxWidth", Le(t.width)), ie(A, c("paddingLeft"), L(!1)), ie(A, c("paddingRight"), L(!0)), D(!0);
  }
  function D(M) {
    var w = te(o);
    (M || _.width !== w.width || _.height !== w.height) && (ie(A, "height", b()), s(c("marginRight"), Le(t.gap)), s("width", O()), s("height", F(), !0), _ = w, a(_t), h !== (h = W()) && (le(o, sr, h), a(_r, h)));
  }
  function L(M) {
    var w = t.padding, S = c(M ? "right" : "left");
    return w && Le(w[S] || (Ye(w) ? 0 : w)) || "0px";
  }
  function b() {
    var M = "";
    return f && (M = y(), He(M, "height or heightRatio is missing."), M = "calc(" + M + " - " + L(!1) + " - " + L(!0) + ")"), M;
  }
  function y() {
    return Le(t.height || te(d).width * t.heightRatio);
  }
  function O() {
    return t.autoWidth ? null : Le(t.fixedWidth) || (f ? "" : C());
  }
  function F() {
    return Le(t.fixedHeight) || (f ? t.autoHeight ? null : C() : y());
  }
  function C() {
    var M = Le(t.gap);
    return "calc((100%" + (M && " + " + M) + ")/" + (t.perPage || 1) + (M && " - " + M) + ")";
  }
  function T() {
    return te(d)[c("width")];
  }
  function N(M, w) {
    var S = g(M || 0);
    return S ? te(S.slide)[c("width")] + (w ? 0 : k()) : 0;
  }
  function R(M, w) {
    var S = g(M);
    if (S) {
      var P = te(S.slide)[c("right")], U = te(d)[c("left")];
      return j(P - U) + (w ? 0 : k());
    }
    return 0;
  }
  function V(M) {
    return R(e.length - 1) - R(0) + N(0, M);
  }
  function k() {
    var M = g(0);
    return M && parseFloat(ie(M.slide, c("marginRight"))) || 0;
  }
  function X(M) {
    return parseFloat(ie(A, c("padding" + (M ? "Right" : "Left")))) || 0;
  }
  function W() {
    return e.is(ot) || V(!0) > T();
  }
  return {
    mount: m,
    resize: D,
    listSize: T,
    slideSize: N,
    sliderSize: V,
    totalSize: R,
    getPadding: X,
    isOverflow: W
  };
}
var zr = 2;
function Br(e, n, t) {
  var r = H(e), i = r.on, v = n.Elements, a = n.Slides, u = n.Direction.resolve, c = [], l;
  function o() {
    i($, A), i([J, ke], g), (l = _()) && (s(l), n.Layout.resize(!0));
  }
  function A() {
    d(), o();
  }
  function d() {
    Oe(c), ge(c), r.destroy();
  }
  function g() {
    var h = _();
    l !== h && (l < h || !h) && r.emit($);
  }
  function s(h) {
    var m = a.get().slice(), E = m.length;
    if (E) {
      for (; m.length < h; )
        ct(m, m);
      ct(m.slice(-h), m.slice(0, h)).forEach(function(D, L) {
        var b = L < h, y = f(D.slide, L);
        b ? Ht(y, m[0].slide) : nt(v.list, y), ct(c, y), a.register(y, L - h + (b ? 0 : E), D.index);
      });
    }
  }
  function f(h, m) {
    var E = h.cloneNode(!0);
    return se(E, t.classes.clone), E.id = e.root.id + "-clone" + $t(m + 1), E;
  }
  function _() {
    var h = t.clones;
    if (!e.is(Be))
      h = 0;
    else if (et(h)) {
      var m = t[u("fixedWidth")] && n.Layout.slideSize(0), E = m && Je(te(v.track)[u("width")] / m);
      h = E || t[u("autoWidth")] && e.length || t.perPage * zr;
    }
    return h;
  }
  return {
    mount: o,
    destroy: d
  };
}
function Gr(e, n, t) {
  var r = H(e), i = r.on, v = r.emit, a = e.state.set, u = n.Layout, c = u.slideSize, l = u.getPadding, o = u.totalSize, A = u.listSize, d = u.sliderSize, g = n.Direction, s = g.resolve, f = g.orient, _ = n.Elements, h = _.list, m = _.track, E;
  function D() {
    E = n.Transition, i([pe, _t, J, $], L);
  }
  function L() {
    n.Controller.isBusy() || (n.Scroll.cancel(), y(e.index), n.Slides.update());
  }
  function b(S, P, U, K) {
    S !== P && M(S > U) && (T(), O(C(V(), S > U), !0)), a(Ue), v(he, P, U, S), E.start(P, function() {
      a(xe), v(ze, P, U, S), K && K();
    });
  }
  function y(S) {
    O(R(S, !0));
  }
  function O(S, P) {
    if (!e.is(ot)) {
      var U = P ? S : F(S);
      ie(h, "transform", "translate" + s("X") + "(" + U + "px)"), S !== U && v(Kn);
    }
  }
  function F(S) {
    if (e.is(Be)) {
      var P = N(S), U = P > n.Controller.getEnd(), K = P < 0;
      (K || U) && (S = C(S, U));
    }
    return S;
  }
  function C(S, P) {
    var U = S - W(P), K = d();
    return S -= f(K * (Je(j(U) / K) || 1)) * (P ? 1 : -1), S;
  }
  function T() {
    O(V(), !0), E.cancel();
  }
  function N(S) {
    for (var P = n.Slides.get(), U = 0, K = 1 / 0, q = 0; q < P.length; q++) {
      var Ee = P[q].index, p = j(R(Ee, !0) - S);
      if (p <= K)
        K = p, U = Ee;
      else
        break;
    }
    return U;
  }
  function R(S, P) {
    var U = f(o(S - 1) - X(S));
    return P ? k(U) : U;
  }
  function V() {
    var S = s("left");
    return te(h)[S] - te(m)[S] + f(l(!1));
  }
  function k(S) {
    return t.trimSpace && e.is(Fe) && (S = be(S, 0, f(d(!0) - A()))), S;
  }
  function X(S) {
    var P = t.focus;
    return P === "center" ? (A() - c(S, !0)) / 2 : +P * c(S) || 0;
  }
  function W(S) {
    return R(S ? n.Controller.getEnd() : 0, !!t.trimSpace);
  }
  function M(S) {
    var P = f(C(V(), S));
    return S ? P >= 0 : P <= h[s("scrollWidth")] - te(m)[s("width")];
  }
  function w(S, P) {
    P = et(P) ? V() : P;
    var U = S !== !0 && f(P) < f(W(!1)), K = S !== !1 && f(P) > f(W(!0));
    return U || K;
  }
  return {
    mount: D,
    move: b,
    jump: y,
    translate: O,
    shift: C,
    cancel: T,
    toIndex: N,
    toPosition: R,
    getPosition: V,
    getLimit: W,
    exceededLimit: w,
    reposition: L
  };
}
function Wr(e, n, t) {
  var r = H(e), i = r.on, v = r.emit, a = n.Move, u = a.getPosition, c = a.getLimit, l = a.toPosition, o = n.Slides, A = o.isEnough, d = o.getLength, g = t.omitEnd, s = e.is(Be), f = e.is(Fe), _ = B(V, !1), h = B(V, !0), m = t.start || 0, E, D = m, L, b, y;
  function O() {
    F(), i([J, $, ht], F), i(_t, C);
  }
  function F() {
    L = d(!0), b = t.perMove, y = t.perPage, E = M();
    var p = be(m, 0, g ? E : L - 1);
    p !== m && (m = p, a.reposition());
  }
  function C() {
    E !== M() && v(ht);
  }
  function T(p, z, Q) {
    if (!Ee()) {
      var Y = R(p), Z = W(Y);
      Z > -1 && (z || Z !== m) && (U(Z), a.move(Y, Z, D, Q));
    }
  }
  function N(p, z, Q, Y) {
    n.Scroll.scroll(p, z, Q, function() {
      var Z = W(a.toIndex(u()));
      U(g ? Ae(Z, E) : Z), Y && Y();
    });
  }
  function R(p) {
    var z = m;
    if (_e(p)) {
      var Q = p.match(/([+\-<>])(\d+)?/) || [], Y = Q[1], Z = Q[2];
      Y === "+" || Y === "-" ? z = k(m + +("" + Y + (+Z || 1)), m) : Y === ">" ? z = Z ? w(+Z) : _(!0) : Y === "<" && (z = h(!0));
    } else
      z = s ? p : be(p, 0, E);
    return z;
  }
  function V(p, z) {
    var Q = b || (q() ? 1 : y), Y = k(m + Q * (p ? -1 : 1), m, !(b || q()));
    return Y === -1 && f && !Mn(u(), c(!p), 1) ? p ? 0 : E : z ? Y : W(Y);
  }
  function k(p, z, Q) {
    if (A() || q()) {
      var Y = X(p);
      Y !== p && (z = p, p = Y, Q = !1), p < 0 || p > E ? !b && (ft(0, p, z, !0) || ft(E, z, p, !0)) ? p = w(S(p)) : s ? p = Q ? p < 0 ? -(L % y || y) : L : p : t.rewind ? p = p < 0 ? E : 0 : p = -1 : Q && p !== z && (p = w(S(z) + (p < z ? -1 : 1)));
    } else
      p = -1;
    return p;
  }
  function X(p) {
    if (f && t.trimSpace === "move" && p !== m)
      for (var z = u(); z === l(p, !0) && ft(p, 0, e.length - 1, !t.rewind); )
        p < m ? --p : ++p;
    return p;
  }
  function W(p) {
    return s ? (p + L) % L || 0 : p;
  }
  function M() {
    for (var p = L - (q() || s && b ? 1 : y); g && p-- > 0; )
      if (l(L - 1, !0) !== l(p, !0)) {
        p++;
        break;
      }
    return be(p, 0, L - 1);
  }
  function w(p) {
    return be(q() ? p : y * p, 0, E);
  }
  function S(p) {
    return q() ? Ae(p, E) : gt((p >= E ? L - 1 : p) / y);
  }
  function P(p) {
    var z = a.toIndex(p);
    return f ? be(z, 0, E) : z;
  }
  function U(p) {
    p !== m && (D = m, m = p);
  }
  function K(p) {
    return p ? D : m;
  }
  function q() {
    return !et(t.focus) || t.isNavigation;
  }
  function Ee() {
    return e.state.is([Ue, je]) && !!t.waitForTransition;
  }
  return {
    mount: O,
    go: T,
    scroll: N,
    getNext: _,
    getPrev: h,
    getAdjacent: V,
    getEnd: M,
    setIndex: U,
    getIndex: K,
    toIndex: w,
    toPage: S,
    toDest: P,
    hasFocus: q,
    isBusy: Ee
  };
}
var Hr = "http://www.w3.org/2000/svg", Xr = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", st = 40;
function Yr(e, n, t) {
  var r = H(e), i = r.on, v = r.bind, a = r.emit, u = t.classes, c = t.i18n, l = n.Elements, o = n.Controller, A = l.arrows, d = l.track, g = A, s = l.prev, f = l.next, _, h, m = {};
  function E() {
    L(), i(J, D);
  }
  function D() {
    b(), E();
  }
  function L() {
    var N = t.arrows;
    N && !(s && f) && F(), s && f && (Ke(m, {
      prev: s,
      next: f
    }), Ze(g, N ? "" : "none"), se(g, h = rn + "--" + t.direction), N && (y(), T(), x([s, f], at, d.id), a(Wn, s, f)));
  }
  function b() {
    r.destroy(), ve(g, h), _ ? (Oe(A ? [s, f] : g), s = f = null) : ue([s, f], nn);
  }
  function y() {
    i([pe, ze, $, we, ht], T), v(f, "click", B(O, ">")), v(s, "click", B(O, "<"));
  }
  function O(N) {
    o.go(N, !0);
  }
  function F() {
    g = A || Me("div", u.arrows), s = C(!0), f = C(!1), _ = !0, nt(g, [s, f]), !A && Ht(g, d);
  }
  function C(N) {
    var R = '<button class="' + u.arrow + " " + (N ? u.prev : u.next) + '" type="button"><svg xmlns="' + Hr + '" viewBox="0 0 ' + st + " " + st + '" width="' + st + '" height="' + st + '" focusable="false"><path d="' + (t.arrowPath || Xr) + '" />';
    return Cn(R);
  }
  function T() {
    if (s && f) {
      var N = e.index, R = o.getPrev(), V = o.getNext(), k = R > -1 && N < R ? c.last : c.prev, X = V > -1 && N > V ? c.first : c.next;
      s.disabled = R < 0, f.disabled = V < 0, x(s, ne, k), x(f, ne, X), a(Hn, s, f, R, V);
    }
  }
  return {
    arrows: m,
    mount: E,
    destroy: b,
    update: T
  };
}
var $r = Yt + "-interval";
function qr(e, n, t) {
  var r = H(e), i = r.on, v = r.bind, a = r.emit, u = yt(t.interval, e.go.bind(e, ">"), y), c = u.isPaused, l = n.Elements, o = n.Elements, A = o.root, d = o.toggle, g = t.autoplay, s, f, _ = g === "pause";
  function h() {
    g && (m(), d && x(d, at, l.track.id), _ || E(), b());
  }
  function m() {
    t.pauseOnHover && v(A, "mouseenter mouseleave", function(F) {
      s = F.type === "mouseenter", L();
    }), t.pauseOnFocus && v(A, "focusin focusout", function(F) {
      f = F.type === "focusin", L();
    }), d && v(d, "click", function() {
      _ ? E() : D(!0);
    }), i([he, At, $], u.rewind), i(he, O);
  }
  function E() {
    c() && n.Slides.isEnough() && (u.start(!t.resetProgress), f = s = _ = !1, b(), a(Jt));
  }
  function D(F) {
    F === void 0 && (F = !0), _ = !!F, b(), c() || (u.pause(), a(Qt));
  }
  function L() {
    _ || (s || f ? D(!1) : E());
  }
  function b() {
    d && (le(d, Pe, !_), x(d, ne, t.i18n[_ ? "play" : "pause"]));
  }
  function y(F) {
    var C = l.bar;
    C && ie(C, "width", F * 100 + "%"), a($n, F);
  }
  function O(F) {
    var C = n.Slides.getAt(F);
    u.set(C && +ae(C.slide, $r) || t.interval);
  }
  return {
    mount: h,
    destroy: u.cancel,
    play: E,
    pause: D,
    isPaused: c
  };
}
function Kr(e, n, t) {
  var r = H(e), i = r.on;
  function v() {
    t.cover && (i(jt, B(u, !0)), i([pe, J, $], B(a, !0)));
  }
  function a(c) {
    n.Slides.forEach(function(l) {
      var o = rt(l.container || l.slide, "img");
      o && o.src && u(c, o, l);
    });
  }
  function u(c, l, o) {
    o.style("background", c ? 'center/cover no-repeat url("' + l.src + '")' : "", !0), Ze(l, c ? "none" : "");
  }
  return {
    mount: v,
    destroy: B(a, !1)
  };
}
var Zr = 10, Jr = 600, Qr = 0.6, jr = 1.5, ei = 800;
function ti(e, n, t) {
  var r = H(e), i = r.on, v = r.emit, a = e.state.set, u = n.Move, c = u.getPosition, l = u.getLimit, o = u.exceededLimit, A = u.translate, d = e.is(Fe), g, s, f = 1;
  function _() {
    i(he, D), i([J, $], L);
  }
  function h(y, O, F, C, T) {
    var N = c();
    if (D(), F && (!d || !o())) {
      var R = n.Layout.sliderSize(), V = Mt(y) * R * gt(j(y) / R) || 0;
      y = u.toPosition(n.Controller.toDest(y % R)) + V;
    }
    var k = Mn(N, y, 1);
    f = 1, O = k ? 0 : O || dt(j(y - N) / jr, ei), s = C, g = yt(O, m, B(E, N, y, T), 1), a(je), v(At), g.start();
  }
  function m() {
    a(xe), s && s(), v(we);
  }
  function E(y, O, F, C) {
    var T = c(), N = y + (O - y) * b(C), R = (N - T) * f;
    A(T + R), d && !F && o() && (f *= Qr, j(R) < Zr && h(l(o(!0)), Jr, !1, s, !0));
  }
  function D() {
    g && g.cancel();
  }
  function L() {
    g && !g.isPaused() && (D(), m());
  }
  function b(y) {
    var O = t.easingFunc;
    return O ? O(y) : 1 - Math.pow(1 - y, 4);
  }
  return {
    mount: _,
    destroy: D,
    scroll: h,
    cancel: L
  };
}
var Ce = {
  passive: !1,
  capture: !0
};
function ni(e, n, t) {
  var r = H(e), i = r.on, v = r.emit, a = r.bind, u = r.unbind, c = e.state, l = n.Move, o = n.Scroll, A = n.Controller, d = n.Elements.track, g = n.Media.reduce, s = n.Direction, f = s.resolve, _ = s.orient, h = l.getPosition, m = l.exceededLimit, E, D, L, b, y, O = !1, F, C, T;
  function N() {
    a(d, wt, Ct, Ce), a(d, bt, Ct, Ce), a(d, ur, V, Ce), a(d, "click", W, {
      capture: !0
    }), a(d, "dragstart", fe), i([pe, J], R);
  }
  function R() {
    var I = t.drag;
    un(!I), b = I === "free";
  }
  function V(I) {
    if (F = !1, !C) {
      var G = Z(I);
      Y(I.target) && (G || !I.button) && (A.isBusy() ? fe(I, !0) : (T = G ? d : window, y = c.is([Ue, je]), L = null, a(T, wt, k, Ce), a(T, bt, X, Ce), l.cancel(), o.cancel(), M(I)));
    }
  }
  function k(I) {
    if (c.is(ut) || (c.set(ut), v(zn)), I.cancelable)
      if (y) {
        l.translate(E + Q(q(I)));
        var G = Ee(I) > Nn, Te = O !== (O = m());
        (G || Te) && M(I), F = !0, v(Bn), fe(I);
      } else
        P(I) && (y = S(I), fe(I));
  }
  function X(I) {
    c.is(ut) && (c.set(xe), v(Gn)), y && (w(I), fe(I)), u(T, wt, k), u(T, bt, X), y = !1;
  }
  function W(I) {
    !C && F && fe(I, !0);
  }
  function M(I) {
    L = D, D = I, E = h();
  }
  function w(I) {
    var G = U(I), Te = K(G), Ge = t.rewind && t.rewindByDrag;
    g(!1), b ? A.scroll(Te, 0, t.snap) : e.is(ot) ? A.go(_(Mt(G)) < 0 ? Ge ? "<" : "-" : Ge ? ">" : "+") : e.is(Fe) && O && Ge ? A.go(m(!0) ? ">" : "<") : A.go(A.toDest(Te), !0), g(!0);
  }
  function S(I) {
    var G = t.dragMinThreshold, Te = Ye(G), Ge = Te && G.mouse || 0, lr = (Te ? G.touch : +G) || 10;
    return j(q(I)) > (Z(I) ? lr : Ge);
  }
  function P(I) {
    return j(q(I)) > j(q(I, !0));
  }
  function U(I) {
    if (e.is(Be) || !O) {
      var G = Ee(I);
      if (G && G < Nn)
        return q(I) / G;
    }
    return 0;
  }
  function K(I) {
    return h() + Mt(I) * Ae(j(I) * (t.flickPower || 600), b ? 1 / 0 : n.Layout.listSize() * (t.flickMaxPages || 1));
  }
  function q(I, G) {
    return z(I, G) - z(p(I), G);
  }
  function Ee(I) {
    return Dt(I) - Dt(p(I));
  }
  function p(I) {
    return D === I && L || D;
  }
  function z(I, G) {
    return (Z(I) ? I.changedTouches[0] : I)["page" + f(G ? "Y" : "X")];
  }
  function Q(I) {
    return I / (O && e.is(Fe) ? Vr : 1);
  }
  function Y(I) {
    var G = t.noDrag;
    return !$e(I, "." + rr + ", ." + Rt) && (!G || !$e(I, G));
  }
  function Z(I) {
    return typeof TouchEvent < "u" && I instanceof TouchEvent;
  }
  function fr() {
    return y;
  }
  function un(I) {
    C = I;
  }
  return {
    mount: N,
    disable: un,
    isDragging: fr
  };
}
var ri = {
  Spacebar: " ",
  Right: Tt,
  Left: St,
  Up: Zn,
  Down: Jn
};
function an(e) {
  return e = _e(e) ? e : e.key, ri[e] || e;
}
var Ln = "keydown";
function ii(e, n, t) {
  var r = H(e), i = r.on, v = r.bind, a = r.unbind, u = e.root, c = n.Direction.resolve, l, o;
  function A() {
    d(), i(J, g), i(J, d), i(he, f);
  }
  function d() {
    var h = t.keyboard;
    h && (l = h === "global" ? window : u, v(l, Ln, _));
  }
  function g() {
    a(l, Ln);
  }
  function s(h) {
    o = h;
  }
  function f() {
    var h = o;
    o = !0, In(function() {
      o = h;
    });
  }
  function _(h) {
    if (!o) {
      var m = an(h);
      m === c(St) ? e.go("<") : m === c(Tt) && e.go(">");
    }
  }
  return {
    mount: A,
    destroy: g,
    disable: s
  };
}
var Xe = Yt + "-lazy", lt = Xe + "-srcset", ai = "[" + Xe + "], [" + lt + "]";
function oi(e, n, t) {
  var r = H(e), i = r.on, v = r.off, a = r.bind, u = r.emit, c = t.lazyLoad === "sequential", l = [ze, we], o = [];
  function A() {
    t.lazyLoad && (d(), i($, d));
  }
  function d() {
    ge(o), g(), c ? h() : (v(l), i(l, s), s());
  }
  function g() {
    n.Slides.forEach(function(m) {
      Xt(m.slide, ai).forEach(function(E) {
        var D = ae(E, Xe), L = ae(E, lt);
        if (D !== E.src || L !== E.srcset) {
          var b = t.classes.spinner, y = E.parentElement, O = rt(y, "." + b) || Me("span", b, y);
          o.push([E, m, O]), E.src || Ze(E, "none");
        }
      });
    });
  }
  function s() {
    o = o.filter(function(m) {
      var E = t.perPage * ((t.preloadPages || 1) + 1) - 1;
      return m[1].isWithin(e.index, E) ? f(m) : !0;
    }), o.length || v(l);
  }
  function f(m) {
    var E = m[0];
    se(m[1].slide, Ft), a(E, "load error", B(_, m)), x(E, "src", ae(E, Xe)), x(E, "srcset", ae(E, lt)), ue(E, Xe), ue(E, lt);
  }
  function _(m, E) {
    var D = m[0], L = m[1];
    ve(L.slide, Ft), E.type !== "error" && (Oe(m[2]), Ze(D, ""), u(jt, D, L), u(ke)), c && h();
  }
  function h() {
    o.length && f(o.shift());
  }
  return {
    mount: A,
    destroy: B(ge, o),
    check: s
  };
}
function si(e, n, t) {
  var r = H(e), i = r.on, v = r.emit, a = r.bind, u = n.Slides, c = n.Elements, l = n.Controller, o = l.hasFocus, A = l.getIndex, d = l.go, g = n.Direction.resolve, s = c.pagination, f = [], _, h;
  function m() {
    E(), i([J, $, ht], m);
    var C = t.pagination;
    s && Ze(s, C ? "" : "none"), C && (i([he, At, we], F), D(), F(), v(Xn, {
      list: _,
      items: f
    }, O(e.index)));
  }
  function E() {
    _ && (Oe(s ? ye(_.children) : _), ve(_, h), ge(f), _ = null), r.destroy();
  }
  function D() {
    var C = e.length, T = t.classes, N = t.i18n, R = t.perPage, V = o() ? l.getEnd() + 1 : Je(C / R);
    _ = s || Me("ul", T.pagination, c.track.parentElement), se(_, h = It + "--" + y()), x(_, de, "tablist"), x(_, ne, N.select), x(_, tn, y() === Nt ? "vertical" : "");
    for (var k = 0; k < V; k++) {
      var X = Me("li", null, _), W = Me("button", {
        class: T.page,
        type: "button"
      }, X), M = u.getIn(k).map(function(S) {
        return S.slide.id;
      }), w = !o() && R > 1 ? N.pageX : N.slideX;
      a(W, "click", B(L, k)), t.paginationKeyboard && a(W, "keydown", B(b, k)), x(X, de, "presentation"), x(W, de, "tab"), x(W, at, M.join(" ")), x(W, ne, Vt(w, k + 1)), x(W, Ve, -1), f.push({
        li: X,
        button: W,
        page: k
      });
    }
  }
  function L(C) {
    d(">" + C, !0);
  }
  function b(C, T) {
    var N = f.length, R = an(T), V = y(), k = -1;
    R === g(Tt, !1, V) ? k = ++C % N : R === g(St, !1, V) ? k = (--C + N) % N : R === "Home" ? k = 0 : R === "End" && (k = N - 1);
    var X = f[k];
    X && (bn(X.button), d(">" + k), fe(T, !0));
  }
  function y() {
    return t.paginationDirection || t.direction;
  }
  function O(C) {
    return f[l.toPage(C)];
  }
  function F() {
    var C = O(A(!0)), T = O(A());
    if (C) {
      var N = C.button;
      ve(N, Pe), ue(N, An), x(N, Ve, -1);
    }
    if (T) {
      var R = T.button;
      se(R, Pe), x(R, An, !0), x(R, Ve, "");
    }
    v(Yn, {
      list: _,
      items: f
    }, C, T);
  }
  return {
    items: f,
    mount: m,
    destroy: E,
    getAt: O,
    update: F
  };
}
var ui = [" ", "Enter"];
function ci(e, n, t) {
  var r = t.isNavigation, i = t.slideFocus, v = [];
  function a() {
    e.splides.forEach(function(s) {
      s.isParent || (l(e, s.splide), l(s.splide, e));
    }), r && o();
  }
  function u() {
    v.forEach(function(s) {
      s.destroy();
    }), ge(v);
  }
  function c() {
    u(), a();
  }
  function l(s, f) {
    var _ = H(s);
    _.on(he, function(h, m, E) {
      f.go(f.is(Be) ? E : h);
    }), v.push(_);
  }
  function o() {
    var s = H(e), f = s.on;
    f(qt, d), f(qn, g), f([pe, J], A), v.push(s), s.emit(Zt, e.splides);
  }
  function A() {
    x(n.Elements.list, tn, t.direction === Nt ? "vertical" : "");
  }
  function d(s) {
    e.go(s.index);
  }
  function g(s, f) {
    Wt(ui, an(f)) && (d(s), fe(f));
  }
  return {
    setup: B(n.Media.set, {
      slideFocus: et(i) ? r : i
    }, !0),
    mount: a,
    destroy: u,
    remount: c
  };
}
function fi(e, n, t) {
  var r = H(e), i = r.bind, v = 0;
  function a() {
    t.wheel && i(n.Elements.track, "wheel", u, Ce);
  }
  function u(l) {
    if (l.cancelable) {
      var o = l.deltaY, A = o < 0, d = Dt(l), g = t.wheelMinThreshold || 0, s = t.wheelSleep || 0;
      j(o) > g && d - v > s && (e.go(A ? "<" : ">"), v = d), c(A) && fe(l);
    }
  }
  function c(l) {
    return !t.releaseWheel || e.state.is(Ue) || n.Controller.getAdjacent(l) !== -1;
  }
  return {
    mount: a
  };
}
var li = 90;
function vi(e, n, t) {
  var r = H(e), i = r.on, v = n.Elements.track, a = t.live && !t.isNavigation, u = Me("span", wr), c = yt(li, B(o, !1));
  function l() {
    a && (d(!n.Autoplay.isPaused()), x(v, Sn, !0), u.textContent = "…", i(Jt, B(d, !0)), i(Qt, B(d, !1)), i([ze, we], B(o, !0)));
  }
  function o(g) {
    x(v, pn, g), g ? (nt(v, u), c.start()) : (Oe(u), c.cancel());
  }
  function A() {
    ue(v, [yn, Sn, pn]), Oe(u);
  }
  function d(g) {
    a && x(v, yn, g ? "off" : "polite");
  }
  return {
    mount: l,
    disable: d,
    destroy: A
  };
}
var di = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media: pr,
  Direction: Sr,
  Elements: xr,
  Slides: Fr,
  Layout: Ur,
  Clones: Br,
  Move: Gr,
  Controller: Wr,
  Arrows: Yr,
  Autoplay: qr,
  Cover: Kr,
  Scroll: ti,
  Drag: ni,
  Keyboard: ii,
  LazyLoad: oi,
  Pagination: si,
  Sync: ci,
  Wheel: fi,
  Live: vi
}), gi = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
}, hi = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  paginationKeyboard: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: !0,
  classes: Dr,
  i18n: gi,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function Ei(e, n, t) {
  var r = n.Slides;
  function i() {
    H(e).on([pe, $], v);
  }
  function v() {
    r.forEach(function(u) {
      u.style("transform", "translateX(-" + 100 * u.index + "%)");
    });
  }
  function a(u, c) {
    r.style("transition", "opacity " + t.speed + "ms " + t.easing), In(c);
  }
  return {
    mount: i,
    start: a,
    cancel: Ct
  };
}
function mi(e, n, t) {
  var r = n.Move, i = n.Controller, v = n.Scroll, a = n.Elements.list, u = B(ie, a, "transition"), c;
  function l() {
    H(e).bind(a, "transitionend", function(g) {
      g.target === a && c && (A(), c());
    });
  }
  function o(g, s) {
    var f = r.toPosition(g, !0), _ = r.getPosition(), h = d(g);
    j(f - _) >= 1 && h >= 1 ? t.useScroll ? v.scroll(f, h, !1, s) : (u("transform " + h + "ms " + t.easing), r.translate(f, !0), c = s) : (r.jump(g), s());
  }
  function A() {
    u(""), v.cancel();
  }
  function d(g) {
    var s = t.rewindSpeed;
    if (e.is(Fe) && s) {
      var f = i.getIndex(!0), _ = i.getEnd();
      if (f === 0 && g >= _ || f >= _ && g === 0)
        return s;
    }
    return t.speed;
  }
  return {
    mount: l,
    start: o,
    cancel: A
  };
}
var _i = /* @__PURE__ */ function() {
  function e(t, r) {
    this.event = H(), this.Components = {}, this.state = Ar(De), this.splides = [], this._o = {}, this._E = {};
    var i = _e(t) ? Dn(document, t) : t;
    He(i, i + " is invalid."), this.root = i, r = me({
      label: ae(i, ne) || "",
      labelledby: ae(i, en) || ""
    }, hi, e.defaults, r || {});
    try {
      me(r, JSON.parse(ae(i, Yt)));
    } catch {
      He(!1, "Invalid JSON");
    }
    this._o = Object.create(me({}, r));
  }
  var n = e.prototype;
  return n.mount = function(r, i) {
    var v = this, a = this.state, u = this.Components;
    He(a.is([De, vt]), "Already mounted!"), a.set(De), this._C = u, this._T = i || this._T || (this.is(ot) ? Ei : mi), this._E = r || this._E;
    var c = Ke({}, di, this._E, {
      Transition: this._T
    });
    return Ie(c, function(l, o) {
      var A = l(v, u, v._o);
      u[o] = A, A.setup && A.setup();
    }), Ie(u, function(l) {
      l.mount && l.mount();
    }), this.emit(pe), se(this.root, br), a.set(xe), this.emit(xt), this;
  }, n.sync = function(r) {
    return this.splides.push({
      splide: r
    }), r.splides.push({
      splide: this,
      isParent: !0
    }), this.state.is(xe) && (this._C.Sync.remount(), r.Components.Sync.remount()), this;
  }, n.go = function(r) {
    return this._C.Controller.go(r), this;
  }, n.on = function(r, i) {
    return this.event.on(r, i), this;
  }, n.off = function(r) {
    return this.event.off(r), this;
  }, n.emit = function(r) {
    var i;
    return (i = this.event).emit.apply(i, [r].concat(ye(arguments, 1))), this;
  }, n.add = function(r, i) {
    return this._C.Slides.add(r, i), this;
  }, n.remove = function(r) {
    return this._C.Slides.remove(r), this;
  }, n.is = function(r) {
    return this._o.type === r;
  }, n.refresh = function() {
    return this.emit($), this;
  }, n.destroy = function(r) {
    r === void 0 && (r = !0);
    var i = this.event, v = this.state;
    return v.is(De) ? H(this).on(xt, this.destroy.bind(this, r)) : (Ie(this._C, function(a) {
      a.destroy && a.destroy(r);
    }, !0), i.emit(Kt), i.destroy(), r && ge(this.splides), v.set(vt)), this;
  }, gr(e, [{
    key: "options",
    get: function() {
      return this._o;
    },
    set: function(r) {
      this._C.Media.set(r, !0, !0);
    }
  }, {
    key: "length",
    get: function() {
      return this._C.Slides.getLength(!0);
    }
  }, {
    key: "index",
    get: function() {
      return this._C.Controller.getIndex();
    }
  }]), e;
}(), on = _i;
on.defaults = {};
on.STATES = Er;
var Rn = [
  [pe, "onMounted"],
  [xt, "onReady"],
  [he, "onMove"],
  [ze, "onMoved"],
  [qt, "onClick"],
  [xn, "onActive"],
  [kn, "onInactive"],
  [Fn, "onVisible"],
  [Un, "onHidden"],
  [$, "onRefresh"],
  [J, "onUpdated"],
  [ke, "onResize"],
  [_t, "onResized"],
  [zn, "onDrag"],
  [Bn, "onDragging"],
  [Gn, "onDragged"],
  [At, "onScroll"],
  [we, "onScrolled"],
  [Kt, "onDestroy"],
  [Wn, "onArrowsMounted"],
  [Hn, "onArrowsUpdated"],
  [Xn, "onPaginationMounted"],
  [Yn, "onPaginationUpdated"],
  [Zt, "onNavigationMounted"],
  [Jt, "onAutoplayPlay"],
  [$n, "onAutoplayPlaying"],
  [Qt, "onAutoplayPause"],
  [jt, "onLazyLoadLoaded"]
];
function sn(...e) {
  return e.filter(Boolean).join(" ");
}
function Et(e) {
  return e !== null && typeof e == "object";
}
function Ut(e, n) {
  if (Array.isArray(e) && Array.isArray(n))
    return e.length === n.length && !e.some((t, r) => !Ut(t, n[r]));
  if (Et(e) && Et(n)) {
    const t = Object.keys(e), r = Object.keys(n);
    return t.length === r.length && !t.some((i) => !Object.prototype.hasOwnProperty.call(n, i) || !Ut(e[i], n[i]));
  }
  return e === n;
}
function Ai(e, n) {
  return e.length === n.length && !e.some((t, r) => t !== n[r]);
}
function yi(e, n) {
  if (e) {
    const t = Object.keys(e);
    for (let r = 0; r < t.length; r++) {
      const i = t[r];
      if (i !== "__proto__" && n(e[i], i) === !1)
        break;
    }
  }
  return e;
}
function zt(e, n) {
  const t = e;
  return yi(n, (r, i) => {
    Array.isArray(r) ? t[i] = r.slice() : Et(r) ? t[i] = zt(Et(t[i]) ? t[i] : {}, r) : t[i] = r;
  }), t;
}
var cr = ({ children: e, className: n, ...t }) => /* @__PURE__ */ Re.createElement("div", {
  className: sn("splide__track", n),
  ...t
}, /* @__PURE__ */ Re.createElement("ul", {
  className: "splide__list"
}, e)), pi = class extends Re.Component {
  constructor() {
    super(...arguments), this.splideRef = Re.createRef(), this.slides = [];
  }
  componentDidMount() {
    const { options: e, extensions: n, transition: t } = this.props, { current: r } = this.splideRef;
    r && (this.splide = new on(r, e), this.bind(this.splide), this.splide.mount(n, t), this.options = zt({}, e || {}), this.slides = this.getSlides());
  }
  componentWillUnmount() {
    this.splide && (this.splide.destroy(), this.splide = void 0), this.options = void 0, this.slides.length = 0;
  }
  componentDidUpdate() {
    if (!this.splide)
      return;
    const { options: e } = this.props;
    e && !Ut(this.options, e) && (this.splide.options = e, this.options = zt({}, e));
    const n = this.getSlides();
    Ai(this.slides, n) || (this.splide.refresh(), this.slides = n);
  }
  sync(e) {
    var n;
    (n = this.splide) == null || n.sync(e);
  }
  go(e) {
    var n;
    (n = this.splide) == null || n.go(e);
  }
  getSlides() {
    var e;
    if (this.splide) {
      const n = (e = this.splide.Components.Elements) == null ? void 0 : e.list.children;
      return n && Array.prototype.slice.call(n) || [];
    }
    return [];
  }
  bind(e) {
    Rn.forEach(([n, t]) => {
      const r = this.props[t];
      typeof r == "function" && e.on(n, (...i) => {
        r(e, ...i);
      });
    });
  }
  omit(e, n) {
    return n.forEach((t) => {
      Object.prototype.hasOwnProperty.call(e, t) && delete e[t];
    }), e;
  }
  render() {
    const { className: e, tag: n = "div", hasTrack: t = !0, children: r, ...i } = this.props;
    return /* @__PURE__ */ Re.createElement(n, {
      className: sn("splide", e),
      ref: this.splideRef,
      ...this.omit(i, ["options", ...Rn.map((v) => v[1])])
    }, t ? /* @__PURE__ */ Re.createElement(cr, null, r) : r);
  }
}, zi = ({ children: e, className: n, ...t }) => /* @__PURE__ */ Re.createElement("li", {
  className: sn("splide__slide", n),
  ...t
}, e);
/*!
 * Splide.js
 * Version  : 4.1.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
const Si = "_carousel_37goy_1", Ti = "_navElements_37goy_10", Ni = "_progress_37goy_19", Li = "_progressBar_37goy_20", Ri = "_track_37goy_46", Ii = "_enableOverflow_37goy_46", Oi = "_navPositionCenter_37goy_55", Pi = "_navElement_37goy_10", wi = "_navElementPrevious_37goy_69", bi = "_navElementNext_37goy_72", Ci = "_navPositionTop_37goy_76", Di = "_draggable_37goy_88", ee = {
  carousel: Si,
  navElements: Ti,
  progress: Ni,
  progressBar: Li,
  track: Ri,
  enableOverflow: Ii,
  navPositionCenter: Oi,
  navElement: Pi,
  navElementPrevious: wi,
  navElementNext: bi,
  navPositionTop: Ci,
  draggable: Di
}, Bi = vr(
  ({
    autoWidth: e = !0,
    children: n,
    className: t,
    label: r,
    overflow: i = "visible",
    navPosition: v = "top",
    navButtonStyle: a = {
      size: "small",
      variant: "black"
    },
    tag: u = "section",
    api: c,
    ...l
  }, o) => {
    var E, D;
    const { api: A } = dr(o, ["api"]), [d, g] = fn(0), [s, f] = fn(1), _ = {
      // default options
      autoWidth: e,
      focus: 0,
      gap: "16px",
      i18n: {
        next: "Move to next slide",
        prev: "Move to previous slide"
      },
      // overridable options
      ...c,
      // required options
      keyboard: "focused",
      omitEnd: !0,
      pagination: !0,
      trimSpace: !0,
      label: r
    }, h = {
      className: Ne(t, ee.carousel, {
        [ee.navPositionCenter]: v === "center",
        [ee.navPositionTop]: v === "top",
        [ee.draggable]: _.drag !== !1
      }),
      ref: A,
      tag: u,
      ...l,
      hasTrack: !1
    }, m = (L, b) => {
      f((L == null ? void 0 : L.Components.Pagination.items.length) || 1), g(100 / s * b);
    };
    return /* @__PURE__ */ cn(
      pi,
      {
        ...h,
        options: _,
        onMounted: (...L) => {
          var b;
          (b = h.onMounted) == null || b.call(h, ...L), m(L[0], 0);
        },
        onMove: (...L) => {
          var O;
          (O = h.onMove) == null || O.call(h, ...L);
          const [b, y] = L;
          m(b, y);
        },
        children: [
          /* @__PURE__ */ cn("div", { className: Ne("splide__arrows", ee.navElements), children: [
            /* @__PURE__ */ We(
              ln,
              {
                className: Ne(
                  "splide__arrow splide__arrow--prev",
                  ee.navElement,
                  ee.navElementPrevious
                ),
                "aria-label": ((E = _.i18n) == null ? void 0 : E.prev) || "",
                icon: "24/symbol/chevron-back",
                ...a
              }
            ),
            /* @__PURE__ */ We(
              ln,
              {
                className: Ne(
                  "splide__arrow splide__arrow--next",
                  ee.navElement,
                  ee.navElementNext
                ),
                "aria-label": ((D = _.i18n) == null ? void 0 : D.next) || "",
                icon: "24/symbol/chevron-forward",
                ...a
              }
            )
          ] }),
          /* @__PURE__ */ We(
            cr,
            {
              className: Ne(ee.track, {
                [ee.enableOverflow]: i === "visible"
              }),
              children: n
            }
          ),
          /* @__PURE__ */ We("div", { className: Ne("splide__progress", ee.progress), children: /* @__PURE__ */ We(
            "div",
            {
              className: Ne("splide__progress__bar", ee.progressBar),
              style: {
                inlineSize: `${100 / s}%`,
                transform: `translate3d(${d}%, 0, 0)`
              }
            }
          ) })
        ]
      }
    );
  }
);
export {
  Bi as Carousel,
  zi as CarouselItem
};
//# sourceMappingURL=index.js.map
